// extracted by mini-css-extract-plugin
module.exports = {"SideDrawer":"SideDrawer_SideDrawer__k6WhT","Open":"SideDrawer_Open__CqjIy","Close":"SideDrawer_Close__9pQt_"};